import API from '@/api'
import ReportsRequestDTO from '@/api/reports/dto/ReportsRequestDTO'

const getReportsDetails = async (request: ReportsRequestDTO): Promise<any> => {
  return await API.ReportsDetailsRepository.getReportsDetails(request)
}

export default getReportsDetails
